import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appThreeDigitDecimalNumber]'
})
export class ThreeDigitDecimalNumberDirective {

  private regex: RegExp = /^\d*\.?\d{0,3}$/;
  
  private specialKeys: string[] = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    'Del'
  ];

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const current: string = this.el.nativeElement.value;
    const position: number = this.el.nativeElement.selectionStart;

    const next: string = [
      current.slice(0, position),
      event.key === 'Decimal' ? '.' : event.key,
      current.slice(position)
    ].join('');

    if (next && !this.regex.test(next)) {
      event.preventDefault();
    }
  }
}